// Issue #10 (VIT-06) : jeton scellé par le serveur, récupéré au moment où le formulaire
// s'affiche et renvoyé tel quel à la soumission. Le serveur y lit l'instant d'affichage et
// refuse les soumissions instantanées — signature d'un envoi scripté.
//
// Le jeton doit être demandé à l'affichage du formulaire, pas au moment de l'envoi : c'est
// l'écart entre les deux qui est mesuré. Le demander juste avant de soumettre ramènerait
// systématiquement un délai nul.
export async function fetchFormToken(signal?: AbortSignal): Promise<string> {
    try {
        const response = await fetch('/FormToken', { signal });
        if (!response.ok) {
            return '';
        } // if
        const json = await response.json();
        return json?.data?.token ?? '';
    } catch {
        // Réseau indisponible ou requête annulée : on renvoie une chaîne vide plutôt que de
        // faire échouer le rendu. Le serveur répondra par un échec explicite invitant à
        // recharger, ce qui vaut mieux qu'un formulaire qui ne s'affiche pas.
        return '';
    } // try ... catch
} // export async function fetchFormToken
